declare global {
    interface Window {
        AFRAME?: any;
    }
}

export const registerAframeComponents = () => {
    const { AFRAME } = window;
    if (!AFRAME || AFRAME.components['gastroflow-model-anchor']) {
        return;
    }

    AFRAME.registerComponent('gastroflow-model-anchor', {
        schema: {
            alignY: { default: 'floor' },
            center: { default: true },
            shadow: { default: true },
        },

        init: function init() {
            this.onModelLoaded = this.onModelLoaded.bind(this);
            this.el.addEventListener('model-loaded', this.onModelLoaded);
        },

        remove: function remove() {
            this.el.removeEventListener('model-loaded', this.onModelLoaded);
        },

        onModelLoaded: function onModelLoaded() {
            const mesh = this.el.getObject3D('mesh');
            if (!mesh) {
                return;
            }

            const box = new AFRAME.THREE.Box3().setFromObject(mesh);
            const center = box.getCenter(new AFRAME.THREE.Vector3());
            const min = box.min.clone();

            if (this.data.center) {
                mesh.position.x -= center.x;
                mesh.position.z -= center.z;
            }

            mesh.position.y -= this.data.alignY === 'center' ? center.y : min.y;

            mesh.traverse((node: any) => {
                if (!node.isMesh) {
                    return;
                }

                node.castShadow = this.data.shadow;
                node.receiveShadow = this.data.shadow;
            });

            this.el.emit('gastroflow-model-centered');
        },
    });
};
